import type { BacktestJobStatus } from '@thinkalpha/platform-ws-client/contracts/backtest.js';
import { UnreachableCaseError } from 'src/lib/util/unreachableCaseError';

/**
 * Visual grouping for `BacktestJobStatus`. The presentation layer keys all of
 * its styling/labels off this kind so the pill rendering stays a single
 * exhaustive switch — when a new status appears in the contract, the
 * `backtestStatusKind` switch fails to compile and forces an explicit choice.
 */
export type BacktestStatusKind = 'active' | 'completed' | 'no_signals' | 'cancelled' | 'failed';

export function backtestStatusKind(status: BacktestJobStatus): BacktestStatusKind {
    switch (status) {
        case 'initializing':
        case 'queued':
        case 'processing':
        case 'reconciling':
            return 'active';
        case 'completed':
            return 'completed';
        case 'no_signals':
            return 'no_signals';
        case 'cancelled':
            return 'cancelled';
        case 'failed':
        case 'rejected':
        case 'reconciliation_error':
            return 'failed';
        default:
            throw new UnreachableCaseError(status);
    }
}

export function isTerminalBacktestJobStatus(status: BacktestJobStatus): boolean {
    return backtestStatusKind(status) !== 'active';
}
